import {
  useCallback,
} from 'react';
import keys from 'lodash/keys';
import {
  isEmptyString,
} from '@populateui/utils';
import {
  isEmptyPatientValue,
} from 'pages/Dashboard/pages/Appointments/pages/List/components/CreatePatientDialog/helpers';

export default function useConditionalRequirementCallback(
  values: Record<string, string>,
) {
  return useCallback((value: string) => {
    const fields: Record<string, string> = values;
    const isRequired = keys(fields).some(
      (fieldKey: string) => !isEmptyPatientValue(fields[fieldKey], fieldKey),
    );
    return isRequired ? !isEmptyString(value) : true;
  }, [values]);
}
